module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "30",
      "height": "18",
      "viewBox": "0 0 30 18",
      "stroke": "black",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.99996 17C9.94548 17 12.3333 14.6122 12.3333 11.6667C12.3333 8.72115 9.94548 6.33333 6.99996 6.33333C4.05444 6.33333 1.66663 8.72115 1.66663 11.6667C1.66663 14.6122 4.05444 17 6.99996 17Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M23 17C25.9455 17 28.3333 14.6122 28.3333 11.6667C28.3333 8.72115 25.9455 6.33333 23 6.33333C20.0544 6.33333 17.6666 8.72115 17.6666 11.6667C17.6666 14.6122 20.0544 17 23 17Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.3333 11.6667L12.6146 11.5253C13.3552 11.155 14.1719 10.9622 14.9999 10.9622C15.828 10.9622 16.6446 11.155 17.3853 11.5253L17.6666 11.6667",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M24.3333 1L28.1173 9.83067C28.2597 10.1626 28.3332 10.5201 28.3333 10.8813V11.6667",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.66662 1L1.88263 9.83067C1.74038 10.1622 1.6669 10.5192 1.66663 10.88V11.6667",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566c421e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/glasses.vue
// module id = 168b9480743a8d03a91b
// module chunks = 89